"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useCoverageExpirationDateFieldState = void 0;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
function useCoverageExpirationDateFieldState(onChangeExpirationDate, policyTerm, effectiveDate) {
    var expirationDateDisabled = isCoverageExpirationDateDisabled(policyTerm);
    (0, react_1.useEffect)(function () {
        if (expirationDateDisabled && effectiveDate) {
            onChangeExpirationDate(getCoverageExpirationDate(effectiveDate, policyTerm));
        }
        else {
            onChangeExpirationDate('');
        }
    }, [policyTerm, effectiveDate]);
    return { disabled: expirationDateDisabled };
}
exports.useCoverageExpirationDateFieldState = useCoverageExpirationDateFieldState;
function isCoverageExpirationDateDisabled(policyTerm) {
    return policyTerm !== 'Other';
}
function getCoverageExpirationDate(effectiveDate, policyTerm) {
    var months = parseInt(policyTerm === null || policyTerm === void 0 ? void 0 : policyTerm.split(/ /)[0].replace(/[^\d]/g, ''), 10);
    if (!months || Number.isNaN(months)) {
        return '';
    }
    return (0, date_fns_1.addMonths)(effectiveDate, months).toISOString();
}
//# sourceMappingURL=index.js.map